// Route-level collision policy for global fixed-position chrome.
//
// Some routes are "chambers": a single focused surface (a chat composer, a
// reader) where floating global widgets physically obstruct the primary
// interaction. Rather than scattering per-widget CSS hacks, routes are
// declared here once and the root layout suppresses nonessential chrome.
//
// Essential chrome is NEVER suppressed: cookie consent (legal), the mobile tab
// bar (navigation), and the mini player (active audio) keep rendering. Chamber
// pages must reserve space for those with `CHAMBER_BOTTOM_RESERVE`.

import { useRouterState } from "@tanstack/react-router";

/** Routes where nonessential floating widgets are suppressed. */
export const CHAMBER_ROUTES = ["/intelligence"] as const;

/** Bottom offset a chamber composer must leave for essential fixed chrome. */
export const CHAMBER_BOTTOM_RESERVE =
  "bottom-[calc(4rem+env(safe-area-inset-bottom))] lg:bottom-0";

export function isChamberPath(pathname: string | null | undefined): boolean {
  if (!pathname) return false;
  const clean = pathname.replace(/\/+$/, "") || "/";
  return CHAMBER_ROUTES.some((r) => clean === r || clean.startsWith(`${r}/`));
}

/**
 * True when nonessential global floating widgets (focus toggle, surge
 * feedback, AI guide bubble, continue thread, install / update prompts) must
 * not render because they would overlap the chamber's primary controls.
 */
export function useFloatingChromeSuppressed(): boolean {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  return isChamberPath(pathname);
}
